/*
  Make sure to change the data-element-tab name and id, keeping the forloop.index
  HTML Usage:
  <element-tabs-wrapper>
    <div class="element-tabs">
      {%- for i in (1..3) -%}
        <button class="element-tabs__tab{%- if forloop.first %} element-tabs__tab--active{%- endif -%}" data-element-tab="tab-{{- forloop.index -}}">
          Tab button {{- forloop.index -}}
        </button>
      {%- endfor -%}
    </div>
    {%- for i in (1..3) -%}
      <div class="element-contents">
        <div id="tab-{{- forloop.index -}}" class="element-tabs__content{%- if forloop.first %} element-tabs__content--active{%- endif -%}" data-element-target>
          Tab content {{- forloop.index -}}
        </div>
      </div>
    {%- endfor -%}
  </element-tabs-wrapper>
*/

class ElementTabsWrapper extends HTMLElement {
  constructor() {
    super();

    this.tabElements = this.querySelectorAll('[data-element-tab]');
    this.tabTargets = this.querySelectorAll('[data-element-target]');

    // Init component - Loop through all tab Elements
    this.tabElements.forEach((tabElement) => {

      // Bind methods on click of a tab Element
      tabElement.addEventListener('click', this.activateTab.bind(this));
      tabElement.addEventListener('click', this.displayTheTarget.bind(this));
    });
  }

  /**
   * Activate the tab
   */
  activateTab(event) {

    // remove the active classes
    this.tabElements.forEach((tabElement) => {
      tabElement.classList.remove('element-tabs__tab--active');
    });

    // Add the active class to the specific clicked element
    event.target.classList.add('element-tabs__tab--active');
  }

  /**
   * Display the target
   */
  displayTheTarget(event) {

    // Get the target Element by ID
    const targetElement = document.getElementById(event.target.dataset.elementTab);

    // Check: if actual target Element exists on the page
    if (targetElement !== null) {

      // remove the active classes
      this.tabTargets.forEach((tabTarget) => {
        tabTarget.classList.remove('element-tabs__content--active');
      });

      // Add the active class to the specific clicked element
      targetElement.classList.add('element-tabs__content--active');

    }
  }
}

if (!customElements.get('element-tabs-wrapper')) {
  customElements.define('element-tabs-wrapper', ElementTabsWrapper);
}